import { IApplicationState } from '../../../../../../../types/types';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getIsUserEssentialPlanOnly } from '../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';

export const checkBackupsTabAllow = (
    state: IApplicationState,
): boolean => {
    if (getIsUserEssentialPlanOnly(state)) {
        const { allowAutoBackupXml } = getAuthUser(state);
        return allowAutoBackupXml;
    }
    return true;
}
